import React from 'react';
import { FormattedMessage } from 'react-intl';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { Button } from '@/components/atoms/Button';
import { Section } from '@/components/atoms/Section';
import { Table } from '@/components/atoms/Table';
import Select from '@/components/atoms/Select';
import Loader from '@/components/atoms/Loader';
import { SVGIcon, SVGIcons } from '@/components/atoms/Icon/SVGIcon';
import { Routes } from '@/core/router/routes.types';
import { ActionsContainer, AdminNotice, Container, SelectorContainer } from './Shifts.style';
import { DeleteShiftModal } from './DeleteShiftModal';
import { useShiftsViewModel } from './Shifts.viewmodel';

export const Shifts: React.FunctionComponent<React.PropsWithChildren> = () => {
    const {
        tabRoutes,
        rows,
        columns,
        isLoading,
        hasRestaurants,
        restaurantOptions,
        selectedRestaurantId,
        shiftToDelete,
        isLoadingDelete,
        handleAddShift,
        handleSelectRestaurant,
        handleCloseDeleteModal,
        handleDeleteShift,
    } = useShiftsViewModel();

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <Container>
                <AdminNotice data-testid="shifts-admin-notice">
                    <SVGIcon icon={SVGIcons.INFO} size={16} />
                    <FormattedMessage id="shift.adminOnly" />
                </AdminNotice>

                <Section
                    title="shift.tableCard.title"
                    subtitle="shift.tableCard.subtitle"
                    actions={
                        <ActionsContainer>
                            <Button buttonType="primary" onClick={handleAddShift} disabled={!hasRestaurants}>
                                <FormattedMessage id="shift.tableCard.action" />
                            </Button>
                        </ActionsContainer>
                    }
                >
                    <SelectorContainer>
                        <Select<number>
                            labelId="shift.restaurantSelector"
                            inputId="shift-restaurant-selector"
                            options={restaurantOptions}
                            value={selectedRestaurantId ?? undefined}
                            onChange={handleSelectRestaurant}
                            placeholder="shift.restaurantSelector.placeholder"
                            disabled={!hasRestaurants}
                        />
                    </SelectorContainer>

                    {isLoading ? (
                        <Loader withContainer />
                    ) : (
                        <Table
                            rows={rows}
                            columns={columns}
                            emptyMessageId={
                                selectedRestaurantId === null ? 'shift.selectRestaurantPrompt' : 'shift.emptyMessage'
                            }
                            onRowClickPath={Routes.EditShift}
                            isSearchable={true}
                            searchPlaceholder="shift.search"
                            filters={['name']}
                            hasPagination={true}
                        />
                    )}
                </Section>
            </Container>
            <DeleteShiftModal
                shift={shiftToDelete}
                isOpen={shiftToDelete !== null}
                onHide={handleCloseDeleteModal}
                onSubmit={handleDeleteShift}
                isLoading={isLoadingDelete}
            />
        </RouterNavigationTabs>
    );
};
